import React from 'react';
import { Shield } from 'lucide-react';
import DynamicPageSections from '../components/site/DynamicPageSections';
import ManagedInfoPageView from '../components/site/ManagedInfoPageView';
import { useSiteStructureSections } from '../hooks/useSiteStructureSections';
import { useManagedInfoPage } from '../hooks/useManagedInfoPage';

const PrivacyPolicyStatic: React.FC = () => (
  <div className="min-h-screen flex flex-col bg-gray-50 pt-16">
    <main className="flex-grow">
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 text-white py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Shield className="w-16 h-16 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
            <p className="text-xl text-blue-100">Configure this page in Admin → Privacy Policy.</p>
          </div>
        </div>
      </section>
    </main>
  </div>
);

const PrivacyPolicy: React.FC = () => {
  const { sections, ready } = useSiteStructureSections('/privacy-policy');
  const { data, loading, error } = useManagedInfoPage('privacy');

  if (!ready || loading) {
    return (
      <div className="min-h-screen flex flex-col pt-20 pb-16 items-center justify-center bg-gray-50 text-gray-500 text-sm">
        Loading…
      </div>
    );
  }

  if (data && !error) {
    return <ManagedInfoPageView data={data} />;
  }

  if (sections.length > 0) {
    return (
      <div className="min-h-screen flex flex-col pb-16 md:pb-0 pt-16">
        <main className="flex-grow bg-gray-50">
          <DynamicPageSections sections={sections} />
        </main>
      </div>
    );
  }

  return <PrivacyPolicyStatic />;
};

export default PrivacyPolicy;
